
import webApi from './webApi'


const visitorService = {
    fetchAll : async( photo, timestamp=0)=>{

        console.log("visitorService::fetchAll::photo="+photo+", timespamp="+timestamp)
        return await webApi.httpGet('visitors', {photo, timestamp})
    },

    fetch : async(id)=>{
        return await webApi.httpGet('visitors/'+id)
    },
    fetchPhotoAndHistory : async(id)=>{
        return await webApi.httpGet('visitors/'+id+"/history_and_photo")
    },

    create : async(application)=>{
        return await webApi.httpPost('visitors', application)
    },
    update : async(application)=>{
        return await webApi.httpPut('visitors', application)
    },

    delete : async(id)=>{
        return await webApi.httpDelete('visitors/'+id)   
    },

    query : async(searchCriteria)=>{
        return await webApi.httpPost('query/visitor', searchCriteria)
    },

    
}




export default visitorService